// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2heTN","content":"ManualTimeModal_content__1XDzf"};